// extracted by mini-css-extract-plugin
module.exports = {"root":"TextContainer_root__12Xr8","intro":"TextContainer_intro__6eOX5"};